import { fileUrl } from "@/lib/api";

export default function EBib({ registration, eventName = "ALLIED VIRTUAL RUN", backgroundPath, sponsorLogos = [] }) {
  if (!registration) return null;
  return (
    <div
      id={`ebib-${registration.id}`}
      className="relative w-[600px] max-w-full aspect-[3/2] bg-[#0A0A0A] text-white border border-[#FF3B30] overflow-hidden"
      style={{ boxShadow: "inset 0 0 0 6px #0A0A0A, inset 0 0 0 7px #FF3B30" }}
      data-testid="ebib-render"
    >
      {backgroundPath && (
        <>
          <img src={fileUrl(backgroundPath)} alt="" crossOrigin="anonymous" className="absolute inset-0 w-full h-full object-cover opacity-40" />
          <div className="absolute inset-0 bg-black/60" />
        </>
      )}
      <div className="absolute inset-0 grain" />
      {/* Top bar */}
      <div className="absolute top-0 left-0 right-0 flex items-center justify-between px-6 pt-4">
        <div>
          <div className="text-[10px] tracking-[0.35em] text-white/60 font-display">{eventName}</div>
          <div className="text-xs tracking-[0.25em] text-[#FF3B30] font-display">OFFICIAL RUNNER</div>
        </div>
        <div className="text-right">
          <div className="text-[10px] tracking-widest text-white/60 font-display">CATEGORY</div>
          <div className="text-xl font-display tracking-widest">{registration.category_name}</div>
        </div>
      </div>
      {/* BIB number */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-center">
          <div className="text-[10px] tracking-[0.35em] text-white/60 font-display">BIB</div>
          <div className="font-display text-[110px] leading-none text-[#FF3B30] font-mono-num" style={{ letterSpacing: "0.02em" }}>
            {registration.bib_number}
          </div>
        </div>
      </div>
      {/* Sponsors */}
      {sponsorLogos.length > 0 && (
        <div className="absolute bottom-[78px] left-0 right-0 flex items-center justify-center gap-3" data-testid="ebib-sponsors">
          {sponsorLogos.map((l, i) => (
            <img key={i} src={fileUrl(l)} alt="" crossOrigin="anonymous" className="h-5 object-contain opacity-90" />
          ))}
        </div>
      )}
      {/* Bottom */}
      <div className="absolute bottom-0 left-0 right-0 px-6 pb-4 flex items-end justify-between">
        <div>
          <div className="text-[10px] tracking-widest text-white/60 font-display">NAME</div>
          <div className="text-2xl font-display tracking-wide">{registration.full_name?.toUpperCase()}</div>
        </div>
        <div className="text-right">
          <div className="text-[10px] tracking-widest text-white/60 font-display">CITY</div>
          <div className="text-sm font-display tracking-wide">{registration.city?.toUpperCase()}</div>
        </div>
      </div>
    </div>
  );
}
